import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /nom-bonic-programa/ultims-capitols/temporada/N/
let path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'ultims-capitols'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);
    path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'custom-radio', '' + mapping.id, 'ultims-capitols'];

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
